import { NgClass, NgIf } from '@angular/common';
import { Component, inject, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';

import { VimeoPlayerModalComponent } from '../vimeo-player-modal/vimeo-player-modal.component';

@Component({
    standalone: true,
    imports: [NgIf, NgClass, OverlayPanelModule, DynamicDialogModule, FontAwesomeModule, TranslateModule],
    selector: 'qwyk-module-info-button',
    templateUrl: './module-info-button.component.html',
    styleUrls: ['./module-info-button.component.scss'],
    providers: [DialogService]
})
export class ModuleInfoButtonComponent {

    private readonly _modal = inject(DialogService);

    @Input() documentationUrl: string | null = null;
    @Input() vimeoVideoId: number | null = null;
    @Input() buttonClass: string | null = null;

    onShowTutorialVideo() {
        const modalRef = this._modal.open(VimeoPlayerModalComponent, {
            position: 'center',
            showHeader: false,
            closable: true,
            width: 'auto',
            contentStyle: {
                'padding': 0
            },
        });

        if (this.vimeoVideoId) {
            const dialogRef = this._modal.dialogComponentRefMap.get(modalRef);
            dialogRef?.changeDetectorRef?.detectChanges();
            const instance = dialogRef?.instance?.componentRef?.instance as VimeoPlayerModalComponent;
            instance.playVideo(this.vimeoVideoId);
        }
    }
}
